import React from 'react';
import {ButtonBase, Typography} from '@mui/material';
import {ArrowBack} from '@mui/icons-material';
import {styled} from "@mui/material/styles";

const SecondaryMainColorText = styled(Typography)(({theme}) => ({
  color: theme.palette.secondary.main,
}));

const GoBackArrow = styled(ArrowBack)(({theme}) => ({
  marginRight: '0.5em',
  color: theme.palette.secondary.main,
}));

interface BackButtonProps {
    children: React.ReactNode;
    [key: string]: any;
}

const BackButton: React.FC<BackButtonProps> = ({ children, ...props }) => {
    return (
      <ButtonBase {...props}>
          <GoBackArrow fontSize='small' />
          <SecondaryMainColorText>
              {children}
          </SecondaryMainColorText>
      </ButtonBase>
    );
};

export default BackButton;
